'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import 'draft-js/dist/Draft.css'
// eslint-disable-next-line import/no-unresolved

// import { save } from 'redux/modules/saveUserData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactDom = require('react-dom');

var _draftJs = require('draft-js');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

require('./SectionAnalysis.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHORT_TITLE_LOWER = 60;
var SHORT_TITLE_UPPER = 210;
var SHORT_TITLE_SHORTER = 'SHORT_TITLE_SHORTER';
var SHORT_TITLE_LONGER = 'SHORT_TITLE_LONGER';
var SHORT_TITLE_OK = 'SHORT_TITLE_OK';

var ANALYSIS_RESULT = {
  "PR": {
    "is_chronological": {
      "positive": "Good job! All your experiences are mentioned in the reverse chronological format",
      "negative": "Looks like your experiences are not in the reverse chronological order. As  \
                  per current industry standards, you are expected to have your experiences listed\
                  in reverse order, starting from your latest, to the oldest."
    },
    "short_title_length_array": {
      "positive": "Positive Text short_title_length_array",
      "negative": "Negative Text short_title_length_array"
    },
    "double_spacing_check_array": {
      "positive": "Positive Text double_spacing_check_array",
      "negative": "Negative Text double_spacing_check_array"
    }

  }
};

var SectionAnalysis = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    text_analysis_data: state.templateData.text_analysis_data,
    info_block: state.templateData.info_block,
    highlighted_action_verb: state.templateData.highlighted_action_verb
  };
}, {
  highlightActionVerb: templateData.highlightActionVerb
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SectionAnalysis, _Component);

  function SectionAnalysis(props) {
    (0, _classCallCheck3.default)(this, SectionAnalysis);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SectionAnalysis.__proto__ || (0, _getPrototypeOf2.default)(SectionAnalysis)).call(this, props));

    _this.state = {
      sectionAnalysisVisible: false,
      section_analysis_object: false
    };

    _this.datedSectionAnalysis = function (data_parent) {
      var experience_array = _this.props.info_block[data_parent];
      var analyzed_data = void 0;
      var is_chronological = true;
      var is_invalid_date = false;
      var loop_index = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(experience_array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var pr_experience = _step.value;

          //checking reverse chronology
          if (is_chronological) {

            if (loop_index > 0) {
              var current_loop_date = experience_array[loop_index]['date_to'];
              var prev_loop_date = experience_array[loop_index - 1]['date_to'];
              if (!(current_loop_date == 'Present' && prev_loop_date == 'Present')) {
                console.log(current_loop_date);
                if (current_loop_date == 'Present') {
                  is_chronological = false;
                  break;
                } else {
                  var current_loop_date_val = new Date(current_loop_date);
                  var prev_loop_date_val = new Date(prev_loop_date);
                  // if (current_loop_date_val == 'Invalid Date' || prev_loop_date_val == 'Invalid Date'){
                  //   is_invalid_date = true;
                  //   break;
                  // }else{}
                  if (prev_loop_date == 'Present') {
                    if (current_loop_date_val > Date.now()) {
                      is_chronological = false;
                      break;
                    }
                  } else if (current_loop_date == 'Present') {
                    if (prev_loop_date_val < Date.now()) {
                      is_chronological = false;
                      break;
                    }
                  } else {
                    if (prev_loop_date_val < current_loop_date_val) {
                      is_chronological = false;
                      break;
                    }
                  }
                }
              }
            }
          }
          loop_index += 1;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var obj = {
        is_chronological: is_chronological
      };
      _this.setState({ section_analysis_object: obj, sectionAnalysisVisible: true });
    };

    _this.doSectionAnalysis = function (data_parent) {
      switch (data_parent) {
        case 'PR':
          _this.datedSectionAnalysis(data_parent);
          break;

      }
    };

    _this.closeSectionAnalysis = function () {
      _this.setState({ sectionAnalysisVisible: false });
    };

    return _this;
  }

  (0, _createClass3.default)(SectionAnalysis, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          sectionAnalysisVisible = _state.sectionAnalysisVisible,
          section_analysis_object = _state.section_analysis_object;
      var data_parent = this.props.data_parent;

      var show_analysis_icon = data_parent === 'PR';

      return _react2.default.createElement(
        'div',
        { style: { position: 'relative' }, className: 'sectionAnalysis sectionAnalysis-' + data_parent },
        show_analysis_icon && _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', onClick: function onClick(e) {
            return _this2.doSectionAnalysis(data_parent);
          }, style: { position: 'absolute', fontSize: '18px' }, name: 'lightbulb outline' }),
        sectionAnalysisVisible && _react2.default.createElement(SectionAnalysisTextBox, {
          data_parent: data_parent,
          section_analysis_object: section_analysis_object,
          closeSectionAnalysis: this.closeSectionAnalysis
        })
      );
    }
  }]);
  return SectionAnalysis;
}(_react.Component)) || _class);
exports.default = SectionAnalysis;

var SectionAnalysisTextBox = function (_Component2) {
  (0, _inherits3.default)(SectionAnalysisTextBox, _Component2);

  function SectionAnalysisTextBox(props) {
    (0, _classCallCheck3.default)(this, SectionAnalysisTextBox);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (SectionAnalysisTextBox.__proto__ || (0, _getPrototypeOf2.default)(SectionAnalysisTextBox)).call(this, props));

    _this3.hasSomeParentTheClass = function (element, classname) {
      if (element.className) {
        if (element.className.split(' ').indexOf(classname) >= 0) return true;
      }
      return element.parentNode && _this3.hasSomeParentTheClass(element.parentNode, classname);
    };

    _this3.closeTextAnalysis = function (e) {

      if (_this3.hasSomeParentTheClass(e.target, 'textAnalysisWrapper') || _this3.hasSomeParentTheClass(e.target, 'sectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'subSectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'resumeAnalysisBox')) {
        _this3.props.closeSectionAnalysis();
      }
    };

    return _this3;
  }

  (0, _createClass3.default)(SectionAnalysisTextBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          data_parent = _props.data_parent,
          section_analysis_object = _props.section_analysis_object;


      var positiveStyle = { color: 'green', icon: 'checkmark' };
      var negativeStyle = { color: 'red', icon: 'close' };

      var is_chronological = section_analysis_object['is_chronological'];

      var is_chronological_style = is_chronological ? positiveStyle : negativeStyle;

      var is_chronological_text = is_chronological ? ANALYSIS_RESULT[data_parent]['is_chronological']['positive'] : ANALYSIS_RESULT[data_parent]['is_chronological']['negative'];

      return _react2.default.createElement(
        _semanticUiReact.Card,
        { className: 'textanalysis-card' },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            _react2.default.createElement(
              'div',
              null,
              ' ',
              data_parent,
              ' Analysis'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', style: { cursor: 'pointer' }, color: 'black', onClick: function onClick(e) {
                return _this4.props.closeSectionAnalysis();
              } })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { style: { padding: '5px', maxHeight: '300px', overflow: 'auto', scrollBehavior: 'auto' } },
          _react2.default.createElement(
            _semanticUiReact.Feed,
            { className: 'textAnalysis-feed', size: 'small', style: { fontSize: '10px' } },
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: is_chronological_style.icon, style: { color: is_chronological_style.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  is_chronological_text
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SectionAnalysisTextBox;
}(_react.Component);

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionAnalysis/SectionAnalysis.js
// module id = 1744
// module chunks = 0